import { useState } from "react";
import { useParams } from "react-router-dom";
import DashboardBody from "./DashboardBody";

const EditDashboard = () => {
  const { id } = useParams();

  // state
  const [data, setData] = useState({});

  return (
    <div className="mt-3 h-100">
      <div className="border p-3 h-100 d-flex flex-column">
        <DashboardBody {...{ mode: "edit", id, data, setData }} />
      </div>{" "}
    </div>
  );
};

export default EditDashboard;
